import { all, fork, put, select, take, takeLatest } from 'redux-saga/effects';

import {
    API_GET_EARLY_REPAYMENT_SIMULATION,
    API_GET_EARLY_REPAYMENT_SIMULATION_SUCCESS
} from '../../../api/lendingAPI/LendingAPI.actions';
import { getCurrentLocation } from '../../../iwRouter/HistoryProvider';
import {
    REQUEST_CHANGE_ROUTER,
    UPDATE_URL
} from '../../../iwRouter/IwRouter.actions';
import { getQueryParameter } from '../../../iwRouter/LocationHelper';
import { FLEXI_12_URL } from '../../dashboard/Dashboard.sagas';
import { SHOW_REPAYMENT_SCHEDULE_MODAL } from '../../modals/repaymentScheduleModal/RepaymentScheduleModal.actions';
import { getAccountByAccountId } from '../../multiLoanDashboard/accountsSelector';
import {
    EARLY_REPAYMENT_CHOOSE_REPAYMENT_AMOUNT_DATA,
    EARLY_REPAYMENT_READY,
    REQUEST_NEW_REPAYMENT_SCHEDULE_TO_REPAY,
    REQUEST_NEW_REPAYMENT_SCHEDULE_TO_REPAY_LOADING,
    SHOW_CHOOSE_REPAYMENT_AMOUNT_STEP,
    UPDATE_REPAYMENT_SCHEDULE_EARLY_REPAYMENT,
    UPDATE_SELECTED_REPAYMENT_AMOUNT
} from '../EarlyRepayment.actions';
import {
    getEarlyRepaymentURLData,
    serialiseInputAmount,
    getInitialRemainingOustandingBalance,
    getInitialRepaymentAmount
} from '../EarlyRepaymentHelper';
import { getEarlyRepaymentAccountId } from '../EarlyRepaymentSelector';

export const chooseRepaymentAmountSagaWorkers = [
    fork(earlyRepaymentShowChooseRepaymentAmountStepWorker),
    fork(earlyRepaymentNewRepaymentScheduleToRepayWorker)
];

function* earlyRepaymentShowChooseRepaymentAmountStepWorker() {
    yield takeLatest(SHOW_CHOOSE_REPAYMENT_AMOUNT_STEP, function* () {
        const currentLocation = getCurrentLocation();
        const urlData = getEarlyRepaymentURLData(currentLocation);
        const accountId = urlData.accountId
            ? urlData.accountId
            : yield select(getEarlyRepaymentAccountId);

        // If no account ID in URL or store, redirect customer
        if (!accountId) {
            return yield put({
                type: REQUEST_CHANGE_ROUTER,
                location: { pathname: FLEXI_12_URL }
            });
        }

        const account = yield select((state) =>
            getAccountByAccountId(state, accountId)
        );

        const outstandingBalance = account.balance.total;
        const initialRemainingOustandingBalance =
            getInitialRemainingOustandingBalance(account);

        let inputAmount;
        if (isNaN(urlData.amount)) {
            inputAmount = getInitialRepaymentAmount(account);
        } else {
            inputAmount = urlData.amount;
        }

        const serialisedInputAmount = serialiseInputAmount(
            inputAmount,
            outstandingBalance
        );

        yield all([
            put({
                type: UPDATE_URL,
                pathname: '/repayment/choose-amount/',
                search: `?amount=${serialisedInputAmount}&accountId=${accountId}`
            }),
            put({
                type: EARLY_REPAYMENT_CHOOSE_REPAYMENT_AMOUNT_DATA,
                accountId,
                inputAmount: serialisedInputAmount,
                outstandingBalance,
                initialRemainingOustandingBalance
            })
        ]);

        yield put({
            type: UPDATE_SELECTED_REPAYMENT_AMOUNT,
            inputAmount: serialisedInputAmount
        });
        yield put({ type: REQUEST_NEW_REPAYMENT_SCHEDULE_TO_REPAY });
        yield take(API_GET_EARLY_REPAYMENT_SIMULATION_SUCCESS);
        yield put({ type: EARLY_REPAYMENT_READY });

        if (urlData.showRepaymentSchedule) {
            yield take(UPDATE_REPAYMENT_SCHEDULE_EARLY_REPAYMENT);
            yield put({ type: SHOW_REPAYMENT_SCHEDULE_MODAL });
        }
    });
}

function* earlyRepaymentNewRepaymentScheduleToRepayWorker() {
    yield takeLatest(REQUEST_NEW_REPAYMENT_SCHEDULE_TO_REPAY, function* () {
        yield put({ type: REQUEST_NEW_REPAYMENT_SCHEDULE_TO_REPAY_LOADING });
        const { selectedInputAmount, outstandingBalance } = yield select(
            ({ earlyRepayment }) => earlyRepayment
        );

        const accountId = getQueryParameter(getCurrentLocation(), 'accountId');

        const serialisedInputAmount = serialiseInputAmount(
            selectedInputAmount,
            outstandingBalance
        );

        yield put({
            type: UPDATE_URL,
            pathname: '/repayment/choose-amount/',
            search: `?amount=${serialisedInputAmount}&accountId=${accountId}`,
            options: { keepScrollPosition: true }
        });
        yield put({
            type: API_GET_EARLY_REPAYMENT_SIMULATION,
            accountId,
            amount: 0
        });
        const initial = yield take(API_GET_EARLY_REPAYMENT_SIMULATION_SUCCESS);

        yield put({
            type: API_GET_EARLY_REPAYMENT_SIMULATION,
            accountId,
            amount: serialisedInputAmount
        });
        const current = yield take(API_GET_EARLY_REPAYMENT_SIMULATION_SUCCESS);

        yield put({
            type: UPDATE_REPAYMENT_SCHEDULE_EARLY_REPAYMENT,
            initial,
            current
        });
    });
}
